import React from 'react'
import { Link } from 'react-router-dom'
import { BsArrowLeft } from 'react-icons/bs'
import { NavSurround } from './NavSurround'
import Footer from './Footer'
import { LocalisationContext } from 'providers/LocalisationProvider'
import 'css/information-pages.css'

export default class Technical extends React.Component {
  static contextType = LocalisationContext

  _localisationService() {
    return this.context
  }

  render() {
    const { authService, telemetryService } = this.props
    return (
      <NavSurround
        authService={authService}
        telemetryService={telemetryService}
        currentPage='technical'
      >
        <div>
          <div className='info-content'>
            {this._renderHeader()}
            {this._renderQuestions()}
          </div>
        </div>
        <Footer />
      </NavSurround>
    )
  }

  _renderHeader() {
    return (
      <div>
        <Link className='info-home-link' to='/'>
          <BsArrowLeft />
          <span>{this._localisationService().getString('nav_home')}</span>
        </Link>
        <h2 className='info-main-heading'>
          {this._localisationService().getString(
            'faq_technical_assistance_title'
          )}
        </h2>
      </div>
    )
  }

  _renderQuestions() {
    return (
      <div>
        <div>{this._renderTechnicalAssistanceContent()}</div>
      </div>
    )
  }

  _renderTechnicalAssistanceContent() {
    return (
      <div>
        {this._renderSubheadedPair('faq_tech_app_broken')}
        {this._renderSubheadedPair('faq_tech_not_visible')}
        {this._renderSubheadedPair('faq_tech_work_offline')}
        {this._renderSubheadedPair('faq_tech_mobile_phone')}
        {this._renderSubheadedPair('faq_tech_download_profile_options')}
      </div>
    )
  }

  _renderSubheadedPair(key) {
    const splitContent = this._localisationService()
      .getString(`${key}_content`)
      .split('\n')
    const splitSpans = splitContent.map((text, i) => <p key={i}>{text}</p>)

    return (
      <div>
        <h3 className='info-sub-heading'>
          {this._localisationService().getString(`${key}_title`)}
        </h3>
        {splitSpans}
      </div>
    )
  }
}
